module.exports = __webpack_public_path__ + "4adc7aa5cafdb9630e73db3963ab167f.mp3";